import styled from "styled-components";
import cssObjectForListItemColorStates from "./functions/cssObjectForListItemColorStates";
import FlexBox from "../../../../layout/boxes/FlexBox/FlexBox";
import { StyledListItemProps } from "../ListItem.types";

const StyledListItem = styled(FlexBox)<StyledListItemProps>`
	list-style-type: none;

	${({ theme, width, withSpace }) => {
		return {
			borderRadius: theme.radii.xs,
			padding: withSpace ? `${theme.space.md} ${theme.space.xs}` : 0,
			width: !width ? "100%" : undefined,
		};
	}}

	${({ theme }) => {
		return {
			gap: theme.space.sm,
			".ListItemSnippet": {
				gap: theme.space.sm,
			},
		};
	}}

  ${({ theme, colorOn }) => {
		return cssObjectForListItemColorStates(theme, colorOn);
	}}

  // LinkSnippet styles

  .ListItemLinkSnippet {
		${({ theme, colorOn }) => {
			const getIconFillHex = (): string | undefined => {
				switch (colorOn) {
					case "bg_dark":
					case "bg_dark_variant": {
						return theme.palette.hexForRole("fg_light_1");
					}
					default:
						return theme.palette.hexForRole("cta_default");
				}
			};

			return {
				".Link": {
					textDecoration: "none",
					width: "100%",
					gap: theme.space.sm,
					padding: `${theme.space.md} ${theme.space.xs}`,
				},
				".Icon svg": {
					fill: getIconFillHex(),
				},
			};
		}}
	}
`;

export { StyledListItem };
